import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  selectSelectedRoles,
  selectRoles,
  selectNumRoles,
} from "../../../../../redux/admin/roles/roles-selector";
import { selectUser } from "../../../../../redux/user/user-selector";
import { setSelectedRoles } from "../../../../../redux/admin/roles/roles-actions";
import FiltersPanel from "../../../../../components/filter-panel/filter-panel";

import ArrowIconDisabled from "../../../../../assets/img/arrow-filter-solid-disabled.svg";
import ArrowIcon from "../../../../../assets/img/arrow-filter-solid.svg";
import FilterIcon from "../../../../../assets/icons/Icon - FilterDisabled.svg";
import FilterIconOn from "../../../../../assets/icons/Icon - Filter.svg";

import { GetAllDepartmentsAPI } from "../../../../../../src/services/api/department-api";
import { GetAllRolesNew } from "../../../../../../src/services/api/role-api";

import "./roles-table-header-new.styles.scss";

const tableHeaderInfo = [
  {
    name: "ROLE NAME",
    filterNames: "Role Name",
    containerClassName: "th-role-name-col",
    hasFilter: true,
    hasSort: true,
    filterType: "RoleRolesNew",
    sortBy: "role",
  },
  {
    name: "ROLE DESCRIPTION",
    filterNames: "",
    containerClassName: "th-description-col",
    hasFilter: false,
    hasSort: false,
    filterType: "",
    sortBy: "",
  },
  {
    name: "DEPARTMENT",
    filterNames: "Department",
    containerClassName: "th-department-col",
    hasFilter: true,
    hasSort: true,
    filterType: "RoleDepartmentsNew",
    sortBy: "department",
  },
  {
    name: "STATUS",
    filterNames: "",
    containerClassName: "th-status-col",
    hasFilter: false,
    hasSort: true,
    filterType: "Roles",
    sortBy: "status",
  },
  {
    name: "ACTIONS",
    filterNames: "",
    containerClassName: "th-admin-actions-col",
    hasFilter: false,
    hasSort: false,
    filterType: "",
    sortBy: "",
  },
];

const RolesTableHeaderNew = ({
  user: { privileges },
  setSelectedRows,
  selectedRows,
  data,
  refreshPage,
  changeData,
}) => {
  const [allRoles, setAllRoles] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);

  //If a filter is active, stores its type so we know this filter is active
  const [activeFilterType, setActiveFilterType] = useState("");
  const [activeSortType, setActiveSortType] = useState("");

  const [isDescendingSort, setIsDescendingSort] = useState(false);

  const [selectedFilterRows, setSelectedFilterRows] = useState([]);

  const onSelectAll = (e) => {
    let tempList = [];
    if (e.target.checked) {
      data.forEach(({ role }) => {
        tempList.push(role.Id);
      });
    }
    setSelectedRows(tempList);
  };

  const getAllData = async () => {
    const totalRoles = await GetAllRolesNew({
      PageSize: 100000,
      PageNumber: 1,
      SortDesc: false,
      SortBy: "name",
      Filters: [],
    });
    totalRoles && setAllRoles(totalRoles.Roles);

    const totalDepartments = await GetAllDepartmentsAPI({
      pageSize: 100000,
      pageNumber: 1,
      sortDesc: false,
      sortBy: "name",
      filters: [],
    });
    totalDepartments && setAllDepartments(totalDepartments.data?.dataList);
  };

  useEffect(() => {
    getAllData();
  }, []);

  const passPayload = (label) => {
    switch (label) {
      case "ROLE NAME":
        return allRoles;
      case "DEPARTMENT":
        return allDepartments;
      default:
        return [];
    }
  };

  const handleSortClick = (sortType) => {
    //All the sortDesc logic is stored in the search query in UsersTableContainer
    if (activeSortType === sortType && !isDescendingSort) {
      //If sorting by ascending, then turn off on this click
      setActiveSortType("");
      setIsDescendingSort(false);
      changeData(undefined, "name", false);
      return;
    }

    if (activeSortType !== sortType) {
      // If not sorting yet, just set to sorting
      setActiveSortType(sortType);
      setIsDescendingSort(true);
      changeData(undefined, sortType, true);
      return;
    }

    //Now sorting upwards
    setIsDescendingSort(false);
    changeData(undefined, sortType, false);
  };

  const updateFilter = (selectedRows, type) => {
    setSelectedFilterRows(selectedRows);
    setActiveFilterType(type);
  };

  const clearFilter = () => {
    setActiveFilterType("");
    setSelectedFilterRows([]);
    refreshPage();
  };

  const saveFilter = (newFilter) => {
    changeData(newFilter);
  };

  return (
    <thead className="role-table-header">
      <tr>
        <th className="th-checkbox-col">
          <Form.Check
            type={"checkbox"}
            disabled={!privileges.Role.Delete}
            onClick={(e) => onSelectAll(e)}
            checked={selectedRows.length === data.length && data.length !== 0}
          />
        </th>
        {tableHeaderInfo.map((labelInfo) => {
          return (
            <th className={labelInfo.containerClassName} key={labelInfo.name}>
              <div className="th-container">
                {labelInfo.hasFilter && (
                  <div className={`th-icon-filter`}>
                    <FiltersPanel
                      selected={
                        activeFilterType === labelInfo.filterType
                          ? selectedFilterRows
                          : []
                      }
                      filterIcon={
                        activeFilterType === labelInfo.filterType
                          ? FilterIconOn
                          : FilterIcon
                      }
                      header={labelInfo.filterNames}
                      type={labelInfo.filterType}
                      updateSelected={updateFilter}
                      save={saveFilter}
                      clear={clearFilter}
                      change={() => {}}
                      close={() => {}}
                      adminPayload={passPayload(labelInfo.name)}
                    ></FiltersPanel>
                  </div>
                )}
                <div className="th-name">{labelInfo.name}</div>
                <div className="arrow-holder">
                  {labelInfo.hasSort && (
                    <div className="arrow-holder">
                      <img
                        className="th-icon-up"
                        src={
                          activeSortType === labelInfo.sortBy &&
                          !isDescendingSort
                            ? ArrowIcon
                            : ArrowIconDisabled
                        }
                        alt="filter-arrow"
                        onClick={() => handleSortClick(labelInfo.sortBy)}
                      />
                      <img
                        className="th-icon-down"
                        src={
                          activeSortType === labelInfo.sortBy &&
                          isDescendingSort
                            ? ArrowIcon
                            : ArrowIconDisabled
                        }
                        alt="filter-arrow"
                        onClick={() => handleSortClick(labelInfo.sortBy)}
                      />
                    </div>
                  )}
                </div>
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

const mapState = createStructuredSelector({
  user: selectUser,
  data: selectRoles,
  selectedRows: selectSelectedRoles,
  numEntries: selectNumRoles,
});

const mapDispatch = (dispatch) => ({
  setSelectedRows: (idList) => dispatch(setSelectedRoles(idList)),
});

RolesTableHeaderNew.propTypes = {
  user: PropTypes.object.isRequired,
  setSelectedRows: PropTypes.func.isRequired,
  selectedRows: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  refreshPage: PropTypes.func.isRequired,
  changeData: PropTypes.func.isRequired,
};
export default connect(mapState, mapDispatch)(RolesTableHeaderNew);
